// generic-roles.ts — Endpoints rôles génériques (R/A/C/I templates).
import { req } from './_internals.js';

export const genericRolesApi = {
  getGenericRoles: () => req('GET', '/generic-roles'),
  createGenericRole: (d: unknown) => req('POST', '/generic-roles', d),
  updateGenericRole: (id: number | string, d: unknown) => req('PUT', '/generic-roles/' + id, d),
  deleteGenericRole: (id: number | string) => req('DELETE', '/generic-roles/' + id),
};
